module.exports = __webpack_public_path__ + "img/3.08fe2a63.svg";